/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_Period_WeekInputs */

const vi_my_grower_report_period_week = /** @type {(inputs: My_Grower_Report_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuần`)
};

/**

* @param {My_Grower_Report_Period_WeekInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_period_week = /** @type {((inputs?: My_Grower_Report_Period_WeekInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_Period_WeekInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_period_week(inputs)
});